export default __webpack_public_path__ + "static/media/dog.c29949da.htm";